// ─── IndexedDB-кэш thumbnails документов ────────────────────────────────────
// Хранит готовые JPEG-blob превью по r2_key.
// Инвалидация бесплатная: при замене документа меняется r2_key → кэш-мисс.
// ВАЖНО: стерильная зона (Emirates ID) этим кэшем НЕ пользуется — только
// документы организации (Trade License, страховка).

const DB_NAME = 'pm_thumb_cache';
const DB_VERSION = 1;
const STORE = 'thumbs';
const MAX_ENTRIES = 50; // защита от бесконечного роста

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        const store = db.createObjectStore(STORE, { keyPath: 'key' });
        store.createIndex('ts', 'ts');
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

/** Получить blob превью по ключу (r2_key). null если нет. */
export async function thumbCacheGet(key) {
  if (!key) return null;
  try {
    const db = await openDb();
    return await new Promise((resolve) => {
      const tx = db.transaction(STORE, 'readonly');
      const req = tx.objectStore(STORE).get(key);
      req.onsuccess = () => resolve(req.result?.blob || null);
      req.onerror = () => resolve(null);
      tx.oncomplete = () => db.close();
    });
  } catch {
    return null; // IDB недоступен (private mode и т.п.) — просто без кэша
  }
}

/** Получить закэшированные метаданные документа (SWR). null если нет. */
export async function metaCacheGet(key) {
  if (!key) return null;
  try {
    const db = await openDb();
    return await new Promise((resolve) => {
      const tx = db.transaction(STORE, 'readonly');
      const req = tx.objectStore(STORE).get(`meta:${key}`);
      req.onsuccess = () => resolve(req.result?.val || null);
      req.onerror = () => resolve(null);
      tx.oncomplete = () => db.close();
    });
  } catch {
    return null;
  }
}

/** Сохранить метаданные документа. */
export async function metaCacheSet(key, val) {
  if (!key || !val) return;
  try {
    const db = await openDb();
    await new Promise((resolve) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).put({ key: `meta:${key}`, val, ts: Date.now() });
      tx.oncomplete = () => { db.close(); resolve(); };
      tx.onerror = () => { db.close(); resolve(); };
    });
  } catch {
    // best-effort
  }
}

/** Полная очистка кэша (вызывать при logout). */
export async function thumbCacheClear() {
  try {
    const db = await openDb();
    await new Promise((resolve) => {
      const tx = db.transaction(STORE, 'readwrite');
      tx.objectStore(STORE).clear();
      tx.oncomplete = () => { db.close(); resolve(); };
      tx.onerror = () => { db.close(); resolve(); };
    });
  } catch {
    // best-effort
  }
}

/** Сохранить blob превью по ключу. Старые записи вытесняются по timestamp. */
export async function thumbCacheSet(key, blob) {
  if (!key || !blob) return;
  try {
    const db = await openDb();
    await new Promise((resolve) => {
      const tx = db.transaction(STORE, 'readwrite');
      const store = tx.objectStore(STORE);
      store.put({ key, blob, ts: Date.now() });
      // Вытеснение: если записей больше MAX_ENTRIES — удаляем самые старые
      const countReq = store.count();
      countReq.onsuccess = () => {
        let excess = countReq.result - MAX_ENTRIES;
        if (excess > 0) {
          const cursorReq = store.index('ts').openCursor();
          cursorReq.onsuccess = () => {
            const cursor = cursorReq.result;
            if (cursor && excess > 0) { cursor.delete(); excess--; cursor.continue(); }
          };
        }
      };
      tx.oncomplete = () => { db.close(); resolve(); };
      tx.onerror = () => { db.close(); resolve(); };
    });
  } catch {
    // ничего — кэш best-effort
  }
}
